import { UsingSpatialGridContentBody } from "../../components/data/data/HelpCenter/UsingSpatialGrid";
import ArticleLayout from "../../components/HelpCenterComponents/ArticleLayout";

  const ARTICLE_TITLES = [
    'Spatial Grid Dashboard',
    'Projects & Workspaces',
    'Grid Editor',
    'Prompt Bar & Intelligent Controls',
    'Asset Library & Reusable Components',
    'Teams, Roles & Collaboration',
    'Tutorials, Guides & In-Platform Learning',
    'Analytics & Experience Insights',
    'Notifications & Activity Monitoring',
  ];

  const TOC_DATA = {
    0: ['Overview', 'Key Sections of the Dashboard'],
    1: [
      'Project Overview',
      'Common Project Types',
      'Workspaces',
      'Organizing at Enterprise Scale',
      'Governance & Control',
    ],
    2: [
      'Editor Overview',
      'Design, Preview & Code Functionality',
      'Scene Creation & Layout',
      'Asset Panel',
      'Components',
      'Transform Controls',
      'Add Assets',
      'Help',
      'Interaction & Behavior Configuration',
      'Publish & Review',
    ],
    3: [
      'Prompt Bar Overview',
      'AI-Assisted Actions',
      'Business User Enablement',
    ],
    4: [
      'Asset Library Overview',
      'Reuse & Consistency',
      'Versioning & Updates',
      'Enterprise Benefits',
    ],
    5: [
      'Team Structure',
      'Role-Based Access',
      'Review & Approval Workflows',
      'Multi-Team Coordination',
    ],
    6: [
      'Guided Tutorials',
      'Contextual Help',
      'Role-Based Learning',
      'Faster Adoption',
    ],
    7: ['Analytics Overview', 'Key Metrics'],
    8: [
      'Notification Types',
      'Activity Feeds',
      'Enterprise Alignment',
      'Operational Awareness',
    ],
  };
  
const UsingSpatialGridArticles = () => {
  return (
    <ArticleLayout
      articleTitles={ARTICLE_TITLES}
      tocData={TOC_DATA}
      ContentBodyComponent={UsingSpatialGridContentBody}
      sectionName="Using Spatial Grid"
      searchPlaceholder="Search the Spatial Grid Help Center"
      showUseCases={true}
      showTitle={true}
    />
  );
};

export default UsingSpatialGridArticles;